import { getClients } from '../api/CLIENTS/clients';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

export const useClients = (page, limit, search) => {
  return useQuery({
    queryKey: ['clients', page, limit, search],
    queryFn: () => getClients(page, limit, search),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
};



